import videoData from '../../Shared/Activities/Data/videos/video.json';

const levelNameMap = {
  'A1': 'A1 – Beginner',
  'A2': 'A2 – Elementary',
  'B1': 'B1 – Intermediate',
  'B2': 'B2 – Upper-Intermediate',
  'C1': 'C1 – Advanced'
};

function slugify(str) {
  return str.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 60);
}

function stripHtml(html) {
  return html.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim();
}

function estimateTime(item) {
  const qCount = item.questions?.length || 0;
  const textLen = item.transcript?.join('').length || 0;
  if (qCount >= 10 || textLen > 5000) return '20 min';
  if (qCount >= 5 || textLen > 2000) return '15 min';
  return '10 min';
}

// Distribute videos across levels for better filtering demo
// Since all videos are B2, we'll assign them to different levels based on topic/complexity
const levelAssignment = {
  'misconceptions': 'B1',
  'giftgiving': 'B1',
  'holidays': 'B1',
  'tipping': 'B1',
  'neighbors': 'B2',
  'sleep': 'B2',
  'gambling': 'B2',
  'technology': 'B2',
  'education': 'B2',
  'AI': 'B2',
  'music': 'B1',
  'art': 'B1',
  'innovation': 'B2',
  'work': 'B2',
  'vacation': 'B1',
  'paid time off': 'B1',
  'culture': 'B1',
  'language': 'B1',
  'history': 'B2',
  'science': 'B2',
  'health': 'B1',
  'psychology': 'B2',
  'economics': 'B2',
  'business': 'B2',
  'society': 'B1',
  'environment': 'B2',
  'food': 'B1',
  'sports': 'B1',
  'travel': 'B1',
  'finance': 'B2',
  'politics': 'B2',
  'media': 'B1',
};

function getAssignedLevel(topic) {
  if (!topic) return 'B2';
  const t = topic.toLowerCase();
  for (const [key, level] of Object.entries(levelAssignment)) {
    if (t.includes(key.toLowerCase())) return level;
  }
  // Alternate remaining videos across levels
  return 'B2';
}

const videosData = videoData.map((video, i) => {
  const assignedLevel = getAssignedLevel(video.topic);
  const title = video.title;
  const baseId = `video-${slugify(title)}`;
  
  // Get description from first transcript paragraph
  let description = '';
  if (video.transcript?.[0]) {
    description = stripHtml(video.transcript[0]).slice(0, 180) + '...';
  } else {
    description = `Video exercise about ${video.topic} at ${assignedLevel} level.`;
  }

  return {
    id: baseId,
    title,
    subtitle: video.topic || 'General',
    category: 'videos',
    theme: 'Listening',
    level: assignedLevel,
    levelname: levelNameMap[assignedLevel],
    time: estimateTime(video),
    description,
    image: `https://img.youtube.com/vi/${video.videoId}/0.jpg`,
    // Preserve original video data for player view
    videoId: video.videoId,
    topic: video.topic,
    vocabulary: video.vocabulary,
    transcript: video.transcript,
    questions: video.questions,
    originalLevel: video.level // Keep original B2
  };
});

export default videosData;